module.exports = __webpack_public_path__ + "img/google.06d69a38.svg";